<div class="offering-available-versions">
  <h1 class="ui-heading-1-bold offering-available-versions-title">
    {{ section() }}
  </h1>

  <table rds-table [dataSource]="availableVersionDataSource" density="spacious">
    <ng-container rdsColumnDef="version">
      <th rds-header-cell *rdsHeaderCellDef>Version</th>
      <td rds-cell *rdsCellDef="let element">
        {{ element.version }}
      </td>
    </ng-container>

    <ng-container rdsColumnDef="status">
      <th rds-header-cell *rdsHeaderCellDef>Status</th>
      <td rds-cell *rdsCellDef="let element">
        <rds-badge size="m" [label]="element.status" type="minimal"></rds-badge>
      </td>
    </ng-container>

    <ng-container rdsColumnDef="compatibility">
      <th rds-header-cell *rdsHeaderCellDef>Compatibility</th>
      <td rds-cell *rdsCellDef="let element">
        <span>{{ element.compatibility }}</span>
      </td>
    </ng-container>

    <ng-container rdsColumnDef="releaseDate">
      <th rds-header-cell *rdsHeaderCellDef>Release date</th>
      <td rds-cell *rdsCellDef="let element">
        <span>{{ element.releaseDate }}</span>
      </td>
    </ng-container>

    <ng-container rdsColumnDef="endOfLifeDate">
      <th rds-header-cell *rdsHeaderCellDef>End-of-life date</th>
      <td rds-cell *rdsCellDef="let element">
        <span>{{ element.endOfLifeDate }}</span>
      </td>
    </ng-container>

    <ng-container rdsColumnDef="additionalInfo">
      <th rds-header-cell *rdsHeaderCellDef>Additional information</th>
      <td rds-cell *rdsCellDef="let element">
        {{ element.additionalInfo }}
      </td>
    </ng-container>

    <tr rds-header-row *rdsHeaderRowDef="availableVersionColumns"></tr>
    <tr rds-row *rdsRowDef="let row; columns: availableVersionColumns"></tr>
  </table>
</div>
